module.exports = __webpack_public_path__ + "img/InstagramIcon.9ceb4da7.png";